var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import Input from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import clsx from "clsx";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import { makeStyles } from "@material-ui/core/styles";
import { useFormControl } from "@material-ui/core/FormControl";
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions;
    return ({
        root: {
            cursor: "pointer",
            minWidth: spacing(7),
            backgroundColor: function (_a) {
                var color = _a.color;
                return color === "primary" ? palette.primary.main : palette.secondary.main;
            },
            transition: transitions.create(["min-width", "background-color"], {
                duration: transitions.duration.standard,
            }),
            "&:not(:focus-within):not($expanded):hover": {
                backgroundColor: function (_a) {
                    var color = _a.color;
                    return lighten(color === "primary" ? palette.primary.main : palette.secondary.main, palette.action.hoverOpacity);
                },
            },
            "& [class*='MuiInputAdornment-positionEnd']": {
                paddingRight: spacing(1),
                opacity: 0,
                pointerEvents: "none",
                transition: transitions.create("opacity", {
                    easing: transitions.easing.easeOut,
                    duration: transitions.duration.standard,
                }),
            },
            "&:focus-within, &$expanded": {
                minWidth: function (_a) {
                    var expandWidth = _a.expandWidth;
                    return expandWidth;
                },
                cursor: "auto",
                backgroundColor: "transparent",
                "& [class*='MuiInputAdornment-positionEnd']": {
                    opacity: 1,
                    pointerEvents: "auto",
                    transition: transitions.create("opacity", {
                        easing: transitions.easing.easeIn,
                        duration: transitions.duration.standard,
                    }),
                },
                "& $adornment": {
                    transform: "translateX(0px)",
                    color: palette.text.primary,
                },
                "& $input": {
                    cursor: "auto",
                    opacity: 1,
                    transform: "translateX(0px)",
                },
                "& $notchedOutline": {
                    borderColor: palette.dividerStrong,
                },
            },
        },
        expanded: {
            // Gotta declare this again because of a JSS bug
            minWidth: function (_a) {
                var expandWidth = _a.expandWidth;
                return expandWidth;
            },
        },
        adornment: {
            minWidth: spacing(8),
            pointerEvents: "none",
            color: function (_a) {
                var color = _a.color;
                return color === "primary"
                    ? palette.primary.contrastText
                    : palette.secondary.contrastText;
            },
            transform: "translateX(".concat(spacing(2) - 2, "px)"),
            transition: transitions.create(["transform", "color"], {
                duration: transitions.duration.standard,
            }),
            // Ugly selectors, but have to reach 30 and 40 in specificity
            "&&&": { alignSelf: "unset" },
            "&&&&": { paddingBottom: 0 },
        },
        input: {
            // Only take as much space as is available
            flex: "1 0 0",
            width: 0,
            opacity: 0,
            transform: "translateX(".concat(spacing(2), "px)"),
            transition: transitions.create(["opacity", "transform"], {
                duration: transitions.duration.standard,
            }),
            cursor: "inherit",
            "&&&": {
                padding: spacing(2, 0),
            },
        },
        notchedOutline: {
            borderColor: "transparent",
        },
    });
}, { name: "EuiCollapseFieldInput" });
export var CollapseFieldInput = function (_a) {
    var _b;
    var classesProp = _a.classes, expandWidth = _a.expandWidth, startIcon = _a.startIcon, other = __rest(_a, ["classes", "expandWidth", "startIcon"]);
    var _c = useFormControl() || {}, filled = _c.filled, focused = _c.focused, color = _c.color;
    var classes = useStyles({ expandWidth: expandWidth, color: color });
    return (React.createElement(Input, __assign({ classes: {
            root: clsx(classes.root, classesProp === null || classesProp === void 0 ? void 0 : classesProp.root, (_b = {},
                _b[classes.expanded] = filled || focused,
                _b)),
            input: clsx(classes.input, classesProp === null || classesProp === void 0 ? void 0 : classesProp.input),
            notchedOutline: clsx(classes.notchedOutline, classesProp === null || classesProp === void 0 ? void 0 : classesProp.notchedOutline),
        }, startAdornment: startIcon && (React.createElement(InputAdornment, { className: classes.adornment, position: "start" }, startIcon)) }, other)));
};
//# sourceMappingURL=CollapseFieldInput.js.map